import { useState, useEffect, useRef } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import { useAppDispatch, useAppSelector } from "@/redux/store"
import { authentication } from "@/redux/slices/auth/authSlice"
import { useTranslation } from "react-i18next"
import { ToastContainer, toast, Slide } from "react-toastify"
import { useForm, FormProvider, SubmitHandler } from "react-hook-form"
import { z } from "zod"
import moment from "moment"
import api from "@/api/api"
import { zodResolver } from "@hookform/resolvers/zod"
import styles from "./addInvite.module.scss"
import { MdLock } from "react-icons/md"
import { Modal, Button } from "react-bootstrap"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import Slider from "@mui/material/Slider"
import Switch from "react-switch"
import Spinner from "react-bootstrap/Spinner"
import InvitesmartLogonew from "@/assets/images/invitesmartLogoneww.png"
import logoinvite from "@/assets/images/logoinvite.jpg"
import {
  StringInput,
  FileDropzone,
  FileDropzoneWithIcon,
  ImageInputNew,
  ImageInputEdit,
} from "@/components/common/formElements"
import {
  clearQrId,
  copyEvent,
  getEvent,
  getEventByHash,
} from "../../redux/slices/events/eventsSlice"
import { extractColorsFromImageUrl } from "@/components/common/parseColorFromImage"
import { ColorPicker } from "@/pages/addInvite/displayColor"
import { ColorPickerQrCode } from "@/pages/addInvite/displayColorQrCode"
import { ColorPickerPremium } from "@/pages/addInvite/displayColorPremium"
import { ColorPickerUnPremium } from "@/pages/addInvite/displayColorUnPremium"
import DisabledColors from "@/pages/addInvite/disabledColors"
import QRGenerator from "@/pages/addInvite/generateQrCode"
import { RgbToHex } from "@/pages/addInvite/displayColor"
import { FontPicker } from "@/pages/addInvite/fontPicker"
import { FontPickerPremium } from "@/pages/addInvite/fontPickerPremium"
import { FontPickerUnPremium } from "@/pages/addInvite/fontPickerUnPremium"
import { BsFillPatchCheckFill } from "react-icons/bs"
import NameLabel from "@/pages/addInvite/nameLabelDevelopment"
import { UpgradeToPremiumPopup } from "@/pages/addInvite/addInvitation/upgradeToPremium"
import { NameOrNumberSizeModal } from "@/pages/addInvite/addInvitation/changeNameOrNumberSizeModal"
import { QRSizeModal } from "@/pages/addInvite/addInvitation/changeQrSizeModal"
const findLatestEntitlement = (entitlements: any) => {
  const now = new Date() // Current date and time
  const entitlementList = Object.values(entitlements)
  // Filter entitlements to only include those that have not expired
  const activeEntitlements = entitlementList.filter((entitlement: any) => {
    return new Date(entitlement.expires_date) > now
  })
  // If no active entitlements, return null or handle appropriately
  if (activeEntitlements.length === 0) return null

  // Find the latest entitlement based on purchase_date
  return activeEntitlements.reduce((latest: any, current: any) => {
    return new Date(current.purchase_date) > new Date(latest.purchase_date)
      ? current
      : latest
  })
}
export const hexToRgb = (hex: string): string => {
  // Remove the hash if present
  const cleanedHex = hex.replace("#", "")

  // Extract RGB components
  const bigint = parseInt(cleanedHex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return `rgb(${r}, ${g}, ${b})`
}
const colorDifference = (color1: string, color2: string) => {
  const [r1, g1, b1] = color1.match(/\d+/g)!.map(Number)
  const [r2, g2, b2] = color2.match(/\d+/g)!.map(Number)
  return Math.sqrt((r2 - r1) ** 2 + (g2 - g1) ** 2 + (b2 - b1) ** 2)
}

const similarityThreshold = 50 // Adjust for stricter or looser filtering

// Font styles array
const fonts = [
  {
    name: "NotoSans_regular",
    label: "Noto Sans",
    fontFamily: "'Noto Sans', sans-serif",
  },
  { name: "Rubik_regular", label: "Rubik", fontFamily: "'Rubik', sans-serif" },
  { name: "Amiri_regular", label: "Amiri", fontFamily: "'Amiri', serif" },
  { name: "Cairo_regular", label: "Cairo", fontFamily: "'Cairo', sans-serif" },
  {
    name: "ScheherazadeNew_regular",
    label: "Scheherazade",
    fontFamily: "'Scheherazade', serif",
  },
  {
    name: "MarkaziText_regular",
    label: "Markazi",
    fontFamily: "'Markazi Text', serif",
  },

  { name: "Lora_regular", label: "Lora", fontFamily: "'Lora', serif" },
  {
    name: "Montserrat_regular",
    label: "Montserrat",
    fontFamily: "'Montserrat', sans-serif",
  },
]
const normalizePosition = (
  value: number,
  maxValue: number,
  defaultLower: number,
  defaultUpper: number,
) => {
  if (value < 0) return defaultLower * maxValue // Below bounds
  if (value > 1) return defaultUpper * maxValue // Above bounds
  return value * maxValue // Within bounds
}
const getImageSizeFromUrl = (
  imageUrl: string,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = imageUrl

    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    }

    img.onerror = (err) => {
      reject(err)
    }
  })
}

const InviteDetail = () => {
  const { t } = useTranslation()
  const { event_id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { isLoading, email, phone, first_name, last_name } = useAppSelector(
    (state) => state?.auth,
  )
  const event: any = useAppSelector((state) => state.events.currentEvent)
  // controls z and
  // const [currentImageUrl, setCurrentImageUrl] = useState<any>(null)
  const [currentEventCreated, setCurrentEventCreated] = useState(null)
  const [loadingPremium, setLoadingPremium] = useState(false)
  const [premium, setPremium] = useState(0)

  const [contacts, setContacts] = useState<any>(null)
  const [qrCodeData, setQrCodeData] = useState<any>(null)
  const [referesh, setRefresh] = useState(false)
  const [loading, setLoading] = useState(false)
  const [upgrade, setUpgrade] = useState(false)
  const [upgradesText, setUpgradeText] = useState("")
  const [upgradeValue, setUpgradeValue] = useState("")

  ////qr code ,name and logo positionining
  const [colors, setColors] = useState<string[]>([])
  const [imageContainerWidth, setImageContainerWidth] = useState(300)
  const [imageContainerHeight, setImageContainerHeight] = useState(300)
  ////qr position and mange
  const [qrPosition, setQrPosition] = useState({ x: 5, y: 2 })
  const [qrValue, setQrValue] = useState<string>("Hello ")
  const [qrSize, setQrSize] = useState(50)
  const [defaultQrSize, setDefaultQrSize] = useState(100)
  const [showQrSize, setShowQrSize] = useState(false)
  const [selectedColor, setSelectedColor] = useState<string>("rgb(0,0,0")
  ///name positioning and manage
  // const [fontType, setFontType] = useState("Noto Sans")
  const [nameSize, setNameSize] = useState(14)
  const [showNameSize, setShowNameSize] = useState(false)
  const [selectedColorName, setSelectedColorName] =
    useState<string>("rgb(0,0,0")
  const [selectedFont, setSelectedFont] = useState<any>(fonts[0])
  const [namePosition, setNamePosition] = useState({ x: 5, y: 50 })
  /////logo positioning
  const [logoPosition, setLogoPosition] = useState({ x: 100, y: 2 })
  ///font and color and toageles
  const [toggleRemoveLogo, setToggleRemoveLogo] = useState(false)
  const [numberOutSideToggle, setNumberOutSideToggle] = useState(false)
  const [uploadedImage, setUploadedImage] = useState(null)
  ////color and front for qrcode and name
  const [isTabActive, setIsTabActive] = useState(true)
  const [loadDone, setLodeDone] = useState(true)
  ////references
  const uploadedImageRef = useRef<HTMLImageElement | null>(null)
  const qrDivRef = useRef<HTMLDivElement | null>(null)
  const nameDivRef = useRef<HTMLDivElement | null>(null)
  const logoDivRef = useRef<HTMLImageElement | null>(null)
  const [imageLoaded, setImageLoaded] = useState(false)
  /////react form hook setup
  const eventSchema = z.object({
    image: z.any(),
    // .refine((files) => files && files.length > 0, {
    //   message: t("event.formSchemas.imageIsRequired"),
    // })
    // .refine(
    //   (files) => {
    //     if (!files || files.length === 0) return true // Skip if no file is provided
    //     const file = files[0] // Since multiple is false, only one file is expected
    //     const validTypes = ["image/jpeg", "image/png", "image/jpg"]
    //     return validTypes.includes(file?.type)
    //   },
    //   {
    //     message: "Allowed formats are JPG, PNG, JPEG.",
    //   },
    // )
    // .refine(
    //   (files) => {
    //     if (!files || files.length === 0) return true // Skip if no file is provided
    //     const file = files[0]
    //     return file?.size <= 5 * 1024 * 1024 // 5MB size limit
    //   },
    //   {
    //     message: "Image size should be less than 5 MB.",
    //   },
    // ),
    // eventName: z.string().min(1, "Event name is required"),
    eventName: z.string().min(1, t("event.formSchemas.invitationTextRequired")),
  })
  type EventFormData = z.infer<typeof eventSchema>
  const methods = useForm<any>({
    resolver: zodResolver(eventSchema),
  })
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = methods

  const formValues = watch()
  ///functiona to manage the upgrade and qr and name size modals

  const handleSetColors = (extractedColors: string[]) => {
    setColors(extractedColors)
  }

  const handleChangeLogoRemoval = () => {
    // if (!formValues?.eventName) {
    //   // toast.error(t("invitation.pleaseFillInvitationNameFirst"))
    //   toast.error(t("invitation.pleaseFillInvitationNameFirst"), {
    //     position: "top-right",
    //     transition: Slide,
    //     autoClose: 2000, // 3 seconds
    //     closeButton: false, // Removes the close button
    //   })
    //   return
    // }
    // if (formValues?.image?.length < 1) {
    //   toast.error(t("invitation.pleaseSelectImageFirst"), {
    //     position: "top-right",
    //     transition: Slide,
    //     autoClose: 2000, // 3 seconds
    //     closeButton: false, // Removes the close button
    //   })
    //   return
    // }

    if (premium !== 1) {
      setUpgradeText("logo_removal")
      setUpgrade(true)
    } else {
      setToggleRemoveLogo(!toggleRemoveLogo)
    }
  }

  const handleChangeFont = () => {
    // if (!formValues?.eventName) {
    //   // toast.error(t("invitation.pleaseFillInvitationNameFirst"))
    //   toast.error(t("invitation.pleaseFillInvitationNameFirst"), {
    //     position: "top-right",
    //     transition: Slide,
    //     autoClose: 2000, // 3 seconds
    //     closeButton: false, // Removes the close button
    //   })
    //   return
    // }

    // if (formValues?.image?.length < 1) {
    //   toast.error(t("invitation.pleaseSelectImageFirst"), {
    //     position: "top-right",
    //     transition: Slide,
    //     autoClose: 2000, // 3 seconds
    //     closeButton: false, // Removes the close button
    //   })
    //   return
    // }
    if (premium != 1) {
      setUpgradeText("fonts")
      setUpgrade(true)
    } else {
    }
  }

  const handleChangeColor = () => {
    // if (!formValues?.eventName) {
    //   // toast.error(t("invitation.pleaseFillInvitationNameFirst"))
    //   toast.error(t("invitation.pleaseFillInvitationNameFirst"), {
    //     position: "top-right",
    //     transition: Slide,
    //     autoClose: 2000, // 3 seconds
    //     closeButton: false, // Removes the close button
    //   })
    //   return
    // }

    // if (formValues?.image?.length < 1) {
    //   toast.error(t("invitation.pleaseSelectImageFirst"), {
    //     position: "top-right",
    //     transition: Slide,
    //     autoClose: 2000, // 3 seconds
    //     closeButton: false, // Removes the close button
    //   })
    //   return
    // }
    if (premium != 1) {
      setUpgradeText("colors")
      setUpgrade(true)
    }
  }

  /////manage draggable qrCode
  const handleDragStart = (event: React.DragEvent<HTMLImageElement>) => {
    event.dataTransfer.setDragImage(new Image(), 0, 0)
  }

  const handleDrag = (event: React.DragEvent<HTMLImageElement>) => {
    // Prevent default drag behavior
    event.preventDefault()

    if (!uploadedImageRef.current) return
    if (!qrDivRef?.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const newX = Math.min(
      Math.max(
        event.clientX - parentRect.left - qrDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - qrDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const newY = Math.min(
      Math.max(
        event.clientY - parentRect.top - qrDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - qrDivRef?.current?.offsetHeight,
    )
    // if(newX<1&&newX!=0&&newY<1&&newY!=0){}
    // setQrPosition({ x: newX, y: newY })

    setQrPosition({ x: newX, y: newY })
    /******  1ced8af2-7e8a-4e5b-892e-72325b645909  *******/
    // setQrPosition({ x: newX, y: newY })
  }
  const handleDragEnd = (event: React.DragEvent<HTMLImageElement>) => {
    if (!uploadedImageRef.current || !qrDivRef.current) return

    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Finalize the position when the drag ends
    const finalX = Math.min(
      Math.max(
        event.clientX - parentRect.left - qrDivRef?.current?.offsetWidth / 2,
        0,
      ),
      parentRect.width - qrDivRef?.current?.offsetWidth,
    )
    const finalY = Math.min(
      Math.max(
        event.clientY - parentRect.top - qrDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - qrDivRef?.current?.offsetHeight,
    )

    // setQrPosition({ x: finalX, y: finalY })
    setQrPosition({ x: finalX, y: finalY })
  }
  const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    const touch = event.touches[0]
  }
  const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault()

    if (!uploadedImageRef.current || !qrDivRef.current) return

    const touch = event.touches[0]
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    const newX = Math.min(
      Math.max(
        touch.clientX - parentRect.left - qrDivRef.current.offsetWidth / 2,
        0,
      ),
      parentRect.width - qrDivRef.current.offsetWidth,
    )

    const newY = Math.min(
      Math.max(
        touch.clientY - parentRect.top - qrDivRef.current.offsetHeight / 2,
        0,
      ),
      parentRect.height - qrDivRef.current.offsetHeight,
    )

    setQrPosition({ x: newX, y: newY })
  }

  ////manage draggable  name
  const handleDragStartName = (event: React.DragEvent<HTMLImageElement>) => {
    event.dataTransfer.setDragImage(new Image(), 0, 0)
  }
  const handleDragName = (event: React.DragEvent<HTMLImageElement>) => {
    // Prevent default drag behavior
    event.preventDefault()

    if (!uploadedImageRef.current) return
    if (!nameDivRef?.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const newX = Math.min(
      Math.max(
        event.clientX - parentRect.left - nameDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - nameDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const newY = Math.min(
      Math.max(
        event.clientY - parentRect.top - nameDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - nameDivRef?.current?.offsetHeight,
    )
    // if(newX<1&&newX!=0&&newY<1&&newY!=0){}
    // setQrPosition({ x: newX, y: newY })

    setNamePosition({ x: newX, y: newY })
    /******  1ced8af2-7e8a-4e5b-892e-72325b645909  *******/
    // setQrPosition({ x: newX, y: newY })
  }
  const handleDragEndName = (event: React.DragEvent<HTMLImageElement>) => {
    if (!uploadedImageRef.current || !nameDivRef.current) return

    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Finalize the position when the drag ends
    const finalX = Math.min(
      Math.max(
        event.clientX - parentRect.left - nameDivRef?.current?.offsetWidth / 2,
        0,
      ),
      parentRect.width - nameDivRef?.current?.offsetWidth,
    )
    const finalY = Math.min(
      Math.max(
        event.clientY - parentRect.top - nameDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - nameDivRef?.current?.offsetHeight,
    )

    // setQrPosition({ x: finalX, y: finalY })
    setNamePosition({ x: finalX, y: finalY })
  }
  const handleTouchStartName = (event: React.TouchEvent<HTMLDivElement>) => {
    const touch = event.touches[0]
  }
  const handleTouchMoveName = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault()

    if (!uploadedImageRef.current || !nameDivRef.current) return

    const touch = event.touches[0]
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    const newX = Math.min(
      Math.max(
        touch.clientX - parentRect.left - nameDivRef.current.offsetWidth / 2,
        0,
      ),
      parentRect.width - nameDivRef.current.offsetWidth,
    )

    const newY = Math.min(
      Math.max(
        touch.clientY - parentRect.top - nameDivRef.current.offsetHeight / 2,
        0,
      ),
      parentRect.height - nameDivRef.current.offsetHeight,
    )

    setNamePosition({ x: newX, y: newY })
  }

  ////manage draggable logo
  const handleDragStartLogo = (event: React.DragEvent<HTMLImageElement>) => {
    event.dataTransfer.setDragImage(new Image(), 0, 0)
  }
  const handleDragLogo = (event: React.DragEvent<HTMLImageElement>) => {
    // Prevent default drag behavior
    event.preventDefault()

    // if (!uploadedImageRef.current) return
    if (!logoDivRef?.current) return
    if (!uploadedImageRef.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const newX = Math.min(
      Math.max(
        event.clientX - parentRect.left - logoDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - logoDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const newY = Math.min(
      Math.max(
        event.clientY - parentRect.top - logoDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - logoDivRef?.current?.offsetHeight - 10,
    )

    // Temporarily update the position during drag
    setLogoPosition({ x: newX, y: newY })
  }
  const handleDragEndLogo = (event: React.DragEvent<HTMLImageElement>) => {
    if (!uploadedImageRef.current) return

    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Finalize the position when the drag ends

    // Calculate the new position of the QR code during dragging
    if (!uploadedImageRef.current) return
    if (!logoDivRef?.current) return
    const finalX = Math.min(
      Math.max(
        event.clientX - parentRect.left - logoDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - logoDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const finalY = Math.min(
      Math.max(
        event.clientY - parentRect.top - logoDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - logoDivRef?.current?.offsetHeight - 10,
    )

    // setLogoPosition({ x: finalX, y: finalY })
    setLogoPosition({ x: finalX, y: finalY })
  }
  const handleTouchStartLogo = (event: React.TouchEvent<HTMLDivElement>) => {
    // Optionally store the initial touch position (if needed)
    const touch = event.touches[0]
  }
  const handleTouchMoveLogo = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault() // Prevent scrolling during drag

    if (!logoDivRef?.current || !uploadedImageRef?.current) return

    const touch = event.touches[0]
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    const newX = Math.min(
      Math.max(
        touch.clientX - parentRect.left - logoDivRef.current.offsetWidth / 2,
        0,
      ),
      parentRect.width - logoDivRef.current.offsetWidth,
    )

    const newY = Math.min(
      Math.max(
        touch.clientY - parentRect.top - logoDivRef.current.offsetHeight / 2,
        0,
      ),
      parentRect.height - logoDivRef.current.offsetHeight,
    )

    // Update position during touch move
    setLogoPosition({ x: newX, y: newY })
  }

  /////check wehn user goes out from the tab and mount when comes in
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIsTabActive(true) // User returned to the tab
      } else {
        setIsTabActive(false) // User left the tab
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])
  /////useffect to fetch the data from the back end and set values,qr,name,logo,size
  useEffect(() => {
    try {
      setLoading(true)
      dispatch(getEvent(Number(event_id))).then(async (res: any) => {
        // qr_code_design_id
        setValue("eventName", res?.payload?.data?.name)
        if (res?.payload?.data?.isPremium == 1) {
          setPremium(1)
        }
        try {
          const qrCodeData: any = await api.events.getQrDesign(
            parseInt(res?.payload?.data?.qr_code_design_id),
          )

          if (qrCodeData && qrCodeData != null) {
            setQrCodeData(qrCodeData?.data?.data)
            const fontSelect: any = fonts.filter(
              (value) => value?.name == qrCodeData?.data?.data?.font_type,
            )
            if (fontSelect?.length > 0) {
              setSelectedFont(fontSelect[0])
            }
            // setSelectedFont(qrCodeData?.data?.data?.font_type)
            const rgbColor = hexToRgb(qrCodeData?.data?.data?.qr_color_code) // Convert HEX to RGB
            const rgbColorName = hexToRgb(
              qrCodeData?.data?.data?.name_color || "#000000",
            ) // Convert HEX to RGB
            setColors((prevColors) => [...prevColors, rgbColor, rgbColorName]) // Add the new color to the list
            setSelectedColor(rgbColor)
            setSelectedColorName(rgbColorName)
            setNumberOutSideToggle(
              qrCodeData?.data?.data?.outside_image == "1" ||
                qrCodeData?.data?.data?.outside_image == 1,
            )

            setToggleRemoveLogo(
              qrCodeData?.data?.data?.remove_logo == "1" ||
                qrCodeData?.data?.data?.remove_logo == 1,
            )
            setImageContainerWidth(qrCodeData?.data?.data?.image_width)
            setImageContainerHeight(qrCodeData?.data?.data?.image_height)

            extractColorsFromImageUrl(
              qrCodeData.data?.data?.image_url,
              (colors) => {
                setColors((prevColors) => {
                  const uniqueColors: string[] = [...prevColors]

                  colors.forEach((newColor) => {
                    const isUnique = uniqueColors.every(
                      (existingColor) =>
                        colorDifference(newColor, existingColor) >
                        similarityThreshold,
                    )

                    if (isUnique) {
                      uniqueColors.push(newColor)
                    }
                  })

                  return uniqueColors
                })
              },
            )
            setUploadedImage(qrCodeData?.data?.data?.image_url)

            // setQrPosition({
            //   x:
            //     qrCodeData?.data?.data?.x_qr *
            //     qrCodeData?.data?.data?.image_width,
            //   y:
            //     qrCodeData?.data?.data?.y_qr *
            //     qrCodeData?.data?.data?.image_height,
            // })
            // setLogoPosition({
            //   x:
            //     qrCodeData?.data?.data?.logo_position_x *
            //     qrCodeData?.data?.data?.image_width,
            //   y:
            //     qrCodeData?.data?.data?.logo_position_y *
            //     qrCodeData?.data?.data?.image_height,
            // })
          }
        } catch {
          setLoading(false)
        }
        const data = {
          id: Number(event_id),
        }
        const contacts = await api.contacts.getContactsOnEventNew(data)
        setContacts(contacts?.data?.data)

        setLoading(false)
      })
    } catch {
      setLoading(false)

      toast.error("Error while fetching the event")
    }
  }, [dispatch, event_id, referesh])
  ////update the size of the image ref width when the  width of the container changes

  useEffect(() => {
    try {
      // Ensure the ref is attached to an element before accessing its properties

      if (uploadedImageRef.current) {
        // const width = uploadedImageRef.current.offsetWidth
        // const height = uploadedImageRef.current.offsetHeight
        // setImageContainerWidth(width)
        // setImageContainerHeight(height)
        // setImageLoaded(true)
        // console.log("true image loaded  ")
      } else {
        // console.log("false aploaded image currecunt")
      }
    } catch (err) {
      // console.log("err", err)
    }
  }, [formValues?.image, uploadedImageRef, loading])
  //update  the position of the qr code size, qr position and logo position when the size of the container have references
  useEffect(() => {
    if (
      uploadedImageRef.current &&
      qrCodeData &&
      qrDivRef.current &&
      logoDivRef.current &&
      nameDivRef.current
    ) {
      try {
        // setLodeDone(true) // Set loading to true at the start
        const {
          x_qr,
          y_qr,
          logo_position_x,
          logo_position_y,
          qr_size,
          name_size,
          name_position_x,
          name_position_y,
        } = qrCodeData

        const imageWidth = qrCodeData?.image_width
        console.log(
          "imageWidth-imageWidth-imageWidth-imageWidth-imageWidth",
          imageWidth,
        )
        // const imageWidth = uploadedImageRef.current.offsetWidth
        // const imageHeight = imageContainerHeight
        // const imageHeight = uploadedImageRef.current.offsetHeight
        const imageHeight = qrCodeData?.image_height
        const qrCodeWidth = qrDivRef.current.offsetWidth
        const qrCodeHeight = qrDivRef.current.offsetHeight
        const nameWidth = nameDivRef.current.offsetWidth
        const nameHeight = nameDivRef.current.offsetHeight
        const logoWidth = logoDivRef.current.offsetWidth
        const logoHeight = logoDivRef.current.offsetHeight
        ///qr code setting
        setQrSize(qr_size * imageWidth)
        // Normalize QR code position and constrain within image boundaries
        setQrPosition({
          x: constrainPosition(
            normalizePosition(x_qr ?? 0, imageWidth, 0.1, 0.9),
            imageWidth,
            qrCodeWidth,
          ),
          y: constrainPosition(
            normalizePosition(y_qr ?? 0, imageHeight, 0.1, 0.9),
            imageHeight,
            qrCodeHeight,
          ),
        })

        ///name settings
        if (
          name_position_x !== null &&
          name_position_y !== null &&
          name_size !== null
        ) {
          setNameSize(name_size)
          // Normalize name  position and constrain within image boundaries
          setNamePosition({
            x: constrainPosition(
              normalizePosition(name_position_x ?? 0, imageWidth, 0.1, 0.9),
              imageWidth,
              nameWidth,
            ),
            y: constrainPosition(
              normalizePosition(name_position_y ?? 0, imageHeight, 0.1, 0.9),
              imageHeight,
              nameHeight,
            ),
          })
        }

        // Normalize Logo position (assuming similar constraints for the logo)
        setLogoPosition({
          x: constrainPosition(
            normalizePosition(logo_position_x ?? 0, imageWidth, 0.1, 0.9),
            imageWidth,
            logoWidth, // Adjust if logo size differs
          ),
          y: constrainPosition(
            normalizePosition(logo_position_y ?? 0, imageHeight, 0.1, 0.9),
            imageHeight,
            logoHeight, // Adjust if logo size differs
          ),
        })

        // setDefaultQrSize(qrCodeData?.data?.data?.qr_size * imageWidth);

        // Helper function to constrain position
        function constrainPosition(
          position: number,
          containerSize: number,
          elementSize: number,
        ) {
          const min = 0 // Start of the container
          const max = containerSize - elementSize // End of the container minus the element's size
          return Math.min(Math.max(position, min), max)
        }
      } catch (error) {
        console.error("Error fetching data:", error)
        toast.error("Error while fetching the event")
      } finally {
        setLodeDone(false) // Set loading to false after all operations are done
      }
    } else {
      console.log("222222222222222222222222222222222222222")
    }
  }, [
    uploadedImageRef.current,
    qrCodeData,
    qrDivRef.current,
    nameDivRef.current,
    logoDivRef.current,
    loading,
    imageLoaded,
    formValues?.image,
  ])

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const identifier = email || phone || ""
        const res = await api.payments.getPovSubscription(identifier)
        const plan: any = findLatestEntitlement(
          res?.data.subscriber?.entitlements,
        )
        if (
          plan?.product_identifier == "pro_plan" ||
          plan?.product_identifier == "unlimited_plan"
        ) {
          setPremium(1)
        } else {
          // setPremium(0)
        }
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }

    fetchSubscription()
  }, [email, phone])

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        dispatch(authentication(null))
          .then((data) => {
            if (
              data?.payload?.invitesmart_subscription &&
              data?.payload?.invitesmart_subscription != "basic"
            ) {
              setPremium(1)
            }
          })
          .catch((error) => {})
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }

    fetchSubscription()
  }, [])
  // Calculate the scaling factors for the image based on container dimensions
  /////resize image
  useEffect(() => {
    if (qrCodeData) {
      // Example usage:
      getImageSizeFromUrl(qrCodeData?.image_url)
        .then(({ width, height }) => {
          // setImageContainerWidth(width)
          // setImageContainerHeight(height)
        })
        .catch((err) => {
          console.error("Failed to load image:", err)
        })
    }
  }, [qrCodeData])

  const onSubmit: SubmitHandler<any> = async (data: any) => {
    // setLoading(true)
    const imageContainerWidth = qrCodeData?.image_width
    const imageContainerHeight = qrCodeData?.image_height

    const formatDate = moment(new Date()).format("Y-MM-DD")
    const formatTime = moment(new Date()).format("HH:mm")

    if (qrCodeData) {
      try {
        setLoading(true)

        const currentDate = new Date()
        // Convert the date to seconds (Unix timestamp)
        const dateInSeconds = Math.floor(currentDate.getTime() / 1000)
        // Convert the timestamp to a string
        const dateInSecondsString = dateInSeconds.toString()
        // setSteps("whatsapNumber")

        // Step 2: Prepare and send event creation totalData

        const eventValues = {
          event_id: event_id,
          source: "invite_smart",
          orientation: "v",
          name: data?.eventName,
          //    guest_type: chooseType,
          simplified: true,
          host_name: "host",
          event_created_date: formatDate,
          event_created_time: formatTime,
          address: {
            address: "Unknown",
            lat: "24.7136",
            lng: "46.6753",
          },
          text_style: {
            font_family: "Oxygen, sans-serif",
            font_size: "2x 1",
            font_style: {
              textBold: false,
              textItalic: false,
              textUnderline: false,
            },
            color: "#000",
            text_align: "center",
          },
          text_position: "flex-start",
          // start_datetime: dayjs
          //   .utc(data?.start_datetime)
          //   .format("YYYY-MM-DD HH:mm:ss"),
          venue: "",
          language: "ar",
          // type: data?.eventType,
          //  image_id: imageId, // Use the uploaded imageId here
          invitation_show_qr_code: true,
          guests_position_x: "",
          guests_position_y: "",
          guests_width_height: "",
          qr_position_x: "",
          qr_position_y: "",
          qr_width_height: "",
          image_width_height: "",
          allow_to_add_invitation_to_wallets: 0,
        }

        const eventRes: any = await api.events.createEvent(eventValues)

        if (eventRes.status === 200) {
          const formData = new FormData()
          //    formData.append("guest_type", chooseType ? chooseType : "name")
          // formData.append("id", Number(qrCodeData?.id))
          formData.append("guests_font_size", "30")
          formData.append("guests_position_x", "160")
          formData.append("guests_position_y", "160")
          formData.append("guests_width_height", "60")
          formData.append("image_width_height", "360")

          formData.append(
            "qr_position_x",
            Math.round(Number(qrPosition?.x)).toString(),
          )
          formData.append(
            "qr_position_y",
            Math.round(Number(qrPosition?.x)).toString(),
          )
          formData.append("qr_width_height", "300")

          //used once

          formData.append("name", dateInSecondsString)
          formData.append(
            "outside_image",
            numberOutSideToggle.toString() == "true" ? "1" : "0",
          )
          formData.append(
            "remove_logo",
            toggleRemoveLogo.toString() == "true" ? "1" : "0",
          )

          //////qr managment
          formData.append("qr_color_code", RgbToHex(selectedColor))
          formData.append(
            "qr_size",
            Number(Number(qrSize) / Number(imageContainerWidth)).toFixed(8),
          )
          formData.append(
            "x_qr",
            Number(Number(qrPosition?.x) / Number(imageContainerWidth)).toFixed(
              8,
            ),
            // .toString(),
          )
          formData.append(
            "y_qr",
            (
              Number(Number(qrPosition?.y)) / Number(imageContainerHeight)
            ).toFixed(8),
            // .toString(),
          )

          /////mane management
          formData.append("name_color", RgbToHex(selectedColorName))
          formData.append("font_type", selectedFont?.name)
          // formData.append(
          //   "name_size",
          //   Number(Number(nameSize) / Number(imageContainerWidth)).toFixed(8),
          // )
          formData.append("name_size", Number(nameSize).toFixed(0))
          formData.append(
            "name_position_x",
            Number(
              Number(namePosition?.x) / Number(imageContainerWidth),
            ).toFixed(8),
          )

          formData.append(
            "name_position_y",
            Number(
              Number(namePosition?.y) / Number(imageContainerHeight),
            ).toFixed(8),
          )
          /////logo management
          formData.append(
            "logo_position_x",
            Number(
              Number(logoPosition?.x) / Number(imageContainerWidth),
            ).toFixed(8),
          )

          formData.append(
            "logo_position_y",
            Number(
              Number(logoPosition?.y) / Number(imageContainerHeight),
            ).toFixed(8),
          )

          formData.append("name", dateInSecondsString)
          formData.append("image_height", qrCodeData?.image_height)
          formData.append("image_width", qrCodeData?.image_width)

          if (data?.image?.length > 0) {
            formData.append("image", data.image[0])
          }

          const eventCodeDesign = await api.events.updateQrCodeDesignNew(
            formData,
            qrCodeData?.id,
          )

          // Step 2: Set event qrc code  using
        }
        navigate(`/`)
        setLoading(false)
      } catch (err: any) {
        const message = err?.response?.data?.message
          ? err?.response?.data?.message
          : "Error while adding contacts , try gain later please"

        toast.error(message)

        setLoading(false)
        console.error("Error while creating event:", err)

        // toast.error("Error while sending the  event")
      }
    } else {
      try {
        setLoading(true)

        const currentDate = new Date()
        // Convert the date to seconds (Unix timestamp)
        const dateInSeconds = Math.floor(currentDate.getTime() / 1000)
        // Convert the timestamp to a string
        const dateInSecondsString = dateInSeconds.toString()
        // setSteps("whatsapNumber")

        // Step 2: Prepare and send event creation totalData
        const formatDate = moment(new Date()).format("Y-MM-DD")
        const formatTime = moment(new Date()).format("HH:mm")

        const eventValues = {
          event_id: event_id,
          source: "invite_smart",
          orientation: "v",
          name: data?.eventName,
          //    guest_type: chooseType,
          simplified: true,
          host_name: "host",
          event_created_date: formatDate,
          event_created_time: formatTime,
          address: {
            address: "Unknown",
            lat: "24.7136",
            lng: "46.6753",
          },
          text_style: {
            font_family: "Oxygen, sans-serif",
            font_size: "2x 1",
            font_style: {
              textBold: false,
              textItalic: false,
              textUnderline: false,
            },
            color: "#000",
            text_align: "center",
          },
          text_position: "flex-start",
          // start_datetime: dayjs
          //   .utc(data?.start_datetime)
          //   .format("YYYY-MM-DD HH:mm:ss"),
          venue: "",
          language: "ar",
          // type: data?.eventType,
          //  image_id: imageId, // Use the uploaded imageId here
          invitation_show_qr_code: true,
          guests_position_x: "",
          guests_position_y: "",
          guests_width_height: "",
          qr_position_x: "",
          qr_position_y: "",
          qr_width_height: "",
          image_width_height: "",
          allow_to_add_invitation_to_wallets: 0,
        }
        const eventRes: any = await api.events.createEvent(eventValues)
        if (eventRes.status === 200) {
          console.log("data.image[0]", data.image[0])
          const formData = new FormData()
          //    formData.append("guest_type", chooseType ? chooseType : "name")
          // formData.append("id", Number(qrCodeData?.id))

          formData.append("guests_font_size", "30")
          formData.append("guests_position_x", "160")
          formData.append("guests_position_y", "160")
          formData.append("guests_width_height", "60")
          formData.append("image_width_height", "360")
          formData.append(
            "qr_width_height",
            Number(qrSize / imageContainerWidth).toFixed(0),
          )

          ////used onece
          formData.append("name", dateInSecondsString)
          formData.append(
            "outside_image",
            numberOutSideToggle.toString() == "true" ? "1" : "0",
          )
          formData.append(
            "remove_logo",
            toggleRemoveLogo.toString() == "true" ? "1" : "0",
          )
          // formData.append("guest_type", chooseType ? chooseType : "name")
          formData.append("font_type", selectedFont?.name)
          formData.append("qr_color_code", RgbToHex(selectedColor))
          formData.append(
            "logo_position_x",
            Number(
              Number(logoPosition?.x) / Number(imageContainerWidth),
            ).toFixed(8),
          ),
            formData.append(
              "logo_position_y",
              Number(
                Number(logoPosition?.y) / Number(imageContainerHeight),
              ).toFixed(8),
            )
          formData.append("name", dateInSecondsString)

          formData.append(
            "qr_position_x",
            Number(Number(qrPosition?.x) / Number(imageContainerWidth)).toFixed(
              0,
            ),
          )

          formData.append(
            "qr_position_y",
            Number(
              Number(qrPosition?.y) / Number(imageContainerHeight),
            ).toFixed(0),
          )

          formData.append(
            "x_qr",
            Number(Number(qrPosition?.x) / Number(imageContainerWidth)).toFixed(
              8,
            ),
            // .toString(),
          )
          formData.append(
            "y_qr",
            (
              Number(Number(qrPosition?.y)) / Number(imageContainerHeight)
            ).toFixed(8),
            // .toString(),
          )
          formData.append(
            "qr_size",
            Number(Number(qrSize) / Number(imageContainerWidth)).toFixed(8),
          )
          ////name size
          formData.append("name_size", Number(nameSize).toFixed(0))
          formData.append(
            "name_position_x",
            Number(
              Number(namePosition?.x) / Number(imageContainerWidth),
            ).toFixed(8),
          )

          formData.append(
            "name_position_y",
            Number(
              Number(namePosition?.y) / Number(imageContainerHeight),
            ).toFixed(8),
          )
          formData.append("image_height", qrCodeData?.image_height)
          formData.append("image_width", qrCodeData?.image_width)

          if (data?.image?.length > 0) {
            formData.append("image", data.image[0])
          }

          try {
            const eventCodeDesign = await api.events.sendQrDesign(formData)
          } catch (err: any) {
            const message = err?.response?.data?.message
              ? err?.response?.data?.message
              : "Error while adding contacts , try gain later please"

            toast.error(message)
          }

          // Step 2: Set event qrc code  using
        }
        navigate(`/`)
        setLoading(false)
      } catch (err: any) {
        const message = err?.response?.data?.message
          ? err?.response?.data?.message
          : "Error while adding contacts , try gain later please"

        toast.error(message)

        setLoading(false)
        console.error("Error while creating event:", err)

        // toast.error("Error while sending the  event")
      }
    }
  }
  useEffect(() => {
    const checkEventStatus = async (eventId: string | number) => {
      try {
        const res = await api.events.checkEventStatus(eventId)
        if (
          premium == 0 &&
          res?.data?.isPremium == 1 &&
          event?.isPremium != 1
        ) {
          toast.success("Event upgraded successfully", {
            position: "top-right",
            transition: Slide,
            autoClose: 2000, // 3 seconds
            closeButton: false, // Removes the close button
          })
          setPremium(res?.data?.isPremium)
        } else {
          // setPremium(res?.data?.isPremium)
        }
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }
    if (event && event !== null) checkEventStatus(event?.event_id)
  }, [isTabActive])

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div className="container" style={{ minHeight: "150vh" }}>
          {qrCodeData && qrCodeData != null ? (
            <>
              <div className="mb-3 " style={{ width: "80px" }}>
                <Button
                  className="d-flex align-items-center "
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "18px",
                    textDecoration: "none",
                    textTransform: "none",
                  }}
                  onClick={() => navigate(-1)}
                >
                  <IconArrowLeft />
                  <span className="reminders-page__link-text">
                    {t("buttons.backNew")}
                  </span>
                </Button>
              </div>{" "}
              <div>
                <h5 className="mt-2 ms-2 ms-md-5 mb-3 fs-3 fw-bold">
                  {" "}
                  {t("invitation.editInvitation")}
                </h5>{" "}
              </div>
              <div>
                {" "}
                {!loading && (
                  <>
                    <FormProvider {...methods}>
                      <form onSubmit={methods.handleSubmit(onSubmit)}>
                        {/* <div className="d-flex flex-column flex-md-row gap-4 "> */}
                        <div
                          className="container  w-full d-flex  flex-column flex-md-row gap-4 mb-3 "
                          // style={{ backgroundColor: "yellow" }}
                        >
                          <div className=" col-12 col-md-6  top-0  align-items-top d-flex flex-column ">
                            {/* {!loadDone && ( */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                // margin: "20px",
                                width: "100%",
                                backgroundColor: "white",
                                borderRadius: "10px",

                                //   backgroundColor: "blue",
                              }}
                              className="d-flex justify-content-center align-items-center"
                            >
                              {/* image div and input */}
                              <div
                                ref={uploadedImageRef}
                                // id="image-container"
                                style={{
                                  position: "relative",
                                  borderRadius: "10px",

                                  // width: "100%",
                                  // height: "auto",

                                  // width: qrCodeData?.image_width,
                                  // height: qrCodeData?.image_height,

                                  width: imageContainerWidth,
                                  height: imageContainerHeight,

                                  // width: "384px",
                                  // height: "384px",
                                  // backgroundColor:"green"

                                  // overflow: "hidden",
                                  // minHeight: "50px",
                                }}
                              >
                                <ImageInputEdit
                                  name="image"
                                  label="Upload Image"
                                  placeholder="Drag or select an image"
                                  imageUrl={
                                    qrCodeData?.image_url
                                      ? qrCodeData?.image_url
                                      : "/vector/no-foto.svg"
                                  } // Optional initial image
                                  setColor={handleSetColors} // Passing setColors function as prop
                                />

                                {/* qrcode and logo inside the image*/}
                                {/* {imageLoaded && ( */}
                                <>
                                  {!numberOutSideToggle && (
                                    <>
                                      <div>
                                        {/* Draggable QR Code */}
                                        <OverlayTrigger
                                          placement="top" // Tooltip position (top, bottom, left, right)
                                          overlay={
                                            <Tooltip id="name-tooltip">
                                              {t(
                                                "invitation.dragToMoveTheQrCodeAndClickToChangeTheSize",
                                              )}
                                            </Tooltip> // Tooltip content
                                          }
                                        >
                                          <div
                                            ref={qrDivRef}
                                            id="qr-container"
                                            className="d-flex  flex-column gap-0 align-items-center"
                                            draggable={true} // Enable dragging if required
                                            onDragStart={handleDragStart}
                                            onDrag={handleDrag}
                                            onDragEnd={handleDragEnd} // Save position on drag end
                                            onTouchStart={handleTouchStart}
                                            onTouchMove={handleTouchMove}
                                            style={{
                                              position: "absolute",
                                              top: `${qrPosition.y}px`,
                                              left: `${qrPosition.x}px`,
                                            }}
                                            onClick={() =>
                                              setShowQrSize(!showQrSize)
                                            }
                                          >
                                            <QRGenerator
                                              value={qrValue}
                                              // bgColor={RgbToHex(selectedColor)}
                                              bgColor={RgbToHex(selectedColor)}
                                              size={qrSize}
                                              // color={RgbToHex(selectedColor)}
                                            />
                                          </div>
                                        </OverlayTrigger>
                                        {/* Draggable Name */}
                                        <OverlayTrigger
                                          placement="top" // Tooltip position (top, bottom, left, right)
                                          overlay={
                                            <Tooltip id="name-tooltip">
                                              {t(
                                                "invitation.dragToMoveTheNameOrNumberAndClickToChangeTheSize",
                                              )}
                                            </Tooltip> // Tooltip content
                                          }
                                        >
                                          <div
                                            ref={nameDivRef}
                                            className="d-flex  flex-column gap-0 align-items-center"
                                            draggable={true} // Enable dragging if required
                                            onDragStart={handleDragStartName}
                                            onDrag={handleDragName}
                                            onDragEnd={handleDragEndName} // Save position on drag end
                                            onTouchStart={handleTouchStartName}
                                            onTouchMove={handleTouchMoveName}
                                            style={{
                                              position: "absolute",
                                              top: `${namePosition.y}px`,
                                              left: `${namePosition.x}px`,
                                            }}
                                            onClick={() =>
                                              setShowNameSize(!showNameSize)
                                            }
                                          >
                                            <NameLabel
                                              label={t(
                                                "invitation.nameOrNumber",
                                              )}
                                              color={RgbToHex(
                                                selectedColorName,
                                              )}
                                              size={nameSize}
                                              font={selectedFont?.fontFamily}
                                            />
                                          </div>
                                        </OverlayTrigger>
                                        {/* Draggable Logo */}
                                        {!toggleRemoveLogo && (
                                          <OverlayTrigger
                                            placement="top" // Tooltip position (top, bottom, left, right)
                                            overlay={
                                              <Tooltip id="name-tooltip">
                                                {t(
                                                  "invitation.dragToMoveTheLogo",
                                                )}
                                              </Tooltip> // Tooltip content
                                            }
                                          >
                                            <img
                                              ref={logoDivRef}
                                              src={InvitesmartLogonew}
                                              alt="Invite Smart Logo"
                                              style={{
                                                position: "absolute",
                                                top: `${logoPosition.y}px`,
                                                left: `${logoPosition.x}px`,
                                                height: "60px",
                                                width: "70px",
                                                // width: "40px",
                                                // height: "50px",
                                                objectFit: "contain",
                                              }}
                                              draggable={true} // Enable dragging if required
                                              onDragStart={handleDragStartLogo}
                                              onDrag={handleDragLogo}
                                              onDragEnd={handleDragEndLogo} // Save position on drag end
                                              onTouchStart={
                                                handleTouchStartLogo
                                              }
                                              onTouchMove={handleTouchMoveLogo}
                                            />
                                          </OverlayTrigger>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </>
                                {/* )} */}
                              </div>

                              {/* Qr code and logo ut side the image  */}
                              {numberOutSideToggle && (
                                <div
                                  style={{
                                    height: "80px",
                                    // width: "100%",
                                    // width: qrCodeData?.image_width,
                                    width: imageContainerWidth,

                                    backgroundColor: "white ",
                                    // marginBottom: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    // padding: numberOutSideToggle ? "15px" : "0px",
                                    // paddingTop: "10px",
                                    alignItems: "bottom ",
                                  }}
                                >
                                  <div className="d-flex flex-row gap-1 align-items-end justify-content-center">
                                    <QRGenerator
                                      value={qrValue}
                                      // bgColor={RgbToHex(selectedColor)}
                                      bgColor={RgbToHex(selectedColor)}
                                      size={70}
                                    />

                                    <div className="mb-2">
                                      <NameLabel
                                        label={t("invitation.nameOrNumber")}
                                        color={RgbToHex(selectedColorName)}
                                        size={nameSize}
                                        font={selectedFont?.fontFamily}
                                      />
                                    </div>
                                  </div>
                                  {!toggleRemoveLogo && (
                                    <div className="mt-2">
                                      <img
                                        src={InvitesmartLogonew}
                                        style={{
                                          height: "60px",
                                          width: "70px",
                                          objectFit: "contain",
                                        }}
                                        alt=""
                                      />
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                            {/* )} */}
                            {/* color for qr code */}
                            <div>
                              {colors?.length > 0 ? (
                                <div
                                  style={{
                                    height: "100px",
                                    backgroundColor: "white ",
                                    // marginBottom: "10px",
                                  }}
                                  className="px-3 pt-2 pb-1 mt-2 d-flex  flex-column  gap-0 rounded-3 shadow-sm"
                                  //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                                >
                                  <h5
                                    className=" d-flex flex-row align-items-center ps-0 pt-2 mb-2"
                                    style={{
                                      fontSize: "1rem",
                                      backgroundColor: "#ffffff",
                                    }}
                                  >
                                    {t("invitation.availableColorsForQrCode")}
                                  </h5>

                                  <div
                                    style={{
                                      flexWrap: "nowrap",
                                      overflowX: "auto",
                                      maxWidth: "100%",
                                      whiteSpace: "nowrap",
                                      scrollbarWidth: "thin",
                                      scrollbarColor: "#8F88 #f1f1f1",
                                      padding: "7px",
                                      backgroundColor: "#eaeaea",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    {premium == 1 ? (
                                      <ColorPickerQrCode
                                        colors={colors}
                                        setColor={setSelectedColor}
                                      />
                                    ) : (
                                      <>
                                        {/* <ColorPickerPremium
                                      colors={colors}
                                      setColor={setSelectedColor}
                                    /> */}
                                        <ColorPickerUnPremium
                                          colors={colors}
                                          setColor={setSelectedColor}
                                          // onColorClick={() =>
                                          //   handleOpenUpgrade("colors")
                                          // }
                                          onColorClick={handleChangeColor}
                                        />
                                      </>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    height: "100px",
                                    backgroundColor: "white ",
                                  }}
                                  className="px-3 py-2 d-flex flex-column  gap-2 rounded-3 shadow-sm"
                                  //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                                >
                                  <DisabledColors
                                    title={t(
                                      "invitation.availableColorsForQrCode",
                                    )}
                                  />
                                </div>
                              )}
                            </div>
                            {/* color for name or number */}
                            <div>
                              {colors?.length > 0 ? (
                                <div
                                  style={{
                                    minHeight: "100px",
                                    backgroundColor: "white ",
                                    // marginBottom: "10px",
                                  }}
                                  className="px-3 pt-2 pb-1 mt-2  d-flex  flex-column  gap-0 rounded-3 shadow-sm"
                                  //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                                >
                                  <h5
                                    className="mb-2 d-flex flex-row align-items-center ps-0 pt-2"
                                    style={{
                                      fontSize: "1rem",
                                      backgroundColor: "#ffffff",
                                    }}
                                  >
                                    {t(
                                      "invitation.availableColorsForNameOrNumber",
                                    )}{" "}
                                  </h5>

                                  <div
                                    style={{
                                      flexWrap: "nowrap",
                                      overflowX: "auto",
                                      maxWidth: "100%",
                                      whiteSpace: "nowrap",
                                      scrollbarWidth: "thin",
                                      scrollbarColor: "#888 #f1f1f1",
                                      padding: "7px",
                                      backgroundColor: "#eaeaea",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    {premium == 1 ? (
                                      <ColorPicker
                                        colors={colors}
                                        setColor={setSelectedColorName}
                                      />
                                    ) : (
                                      <>
                                        {/* <ColorPickerPremium
                                      colors={colors}
                                      setColor={setSelectedColor}
                                    /> */}
                                        <ColorPickerUnPremium
                                          colors={colors}
                                          setColor={setSelectedColorName}
                                          // onColorClick={() =>
                                          //   handleOpenUpgrade("colors")
                                          // }
                                          onColorClick={handleChangeColor}
                                        />
                                      </>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    height: "100px",
                                    backgroundColor: "white ",
                                  }}
                                  className="px-3 py-2 d-flex flex-column  gap-2 rounded-3 shadow-sm"
                                  //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                                >
                                  <DisabledColors
                                    title={t(
                                      "invitation.availableColorsForNameOrNumber",
                                    )}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          {/* right end */}
                          <div
                            className="col-12 col-md-5 gap-3 mt-4 "
                            style={{
                              // backgroundColor: "#F7F5F5",
                              // backgroundColor: "blue",

                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                              marginLeft: "auto",
                            }}
                          >
                            {/* text field to accept invite name */}
                            <div style={{ height: "60px" }}>
                              <StringInput
                                name="eventName"
                                label={t("invitation.inviteName")}
                                placeholder={t("invitation.addInvitationText")}
                              />
                            </div>

                            {/* font change selection */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "7px",
                                alignItems: "center",
                                backgroundColor: "#ffffff",
                                height: "80px",
                              }}
                            >
                              <h5
                                className="d-flex flex-row align-items-center mb-3 ps-3 pe-3"
                                style={{ fontSize: "1rem" }}
                              >
                                {t("invitation.fonts")}
                              </h5>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "10px",
                                  flexWrap: "nowrap",
                                  overflowX: "auto",
                                  maxWidth: "78%",
                                  whiteSpace: "nowrap",
                                  scrollbarWidth: "thin",
                                  scrollbarColor: "#888 #f1f1f1",
                                  paddingBottom: "10px",
                                  // backgroundColor: "#ffffff",
                                }}
                              >
                                {premium == 1 ? (
                                  <FontPicker
                                    fonts={fonts}
                                    selectedFont={selectedFont}
                                    setFont={setSelectedFont}
                                  />
                                ) : (
                                  <>
                                    {/* <FontPickerPremium
                                  fonts={fonts}
                                  selectedFont={selectedFont}
                                  setFont={setSelectedFont}
                                /> */}
                                    <FontPickerUnPremium
                                      fonts={fonts}
                                      selectedFont={selectedFont}
                                      setFont={setSelectedFont}
                                      onColorClick={handleChangeFont}
                                      // onColorClick={() =>
                                      //   handleOpenUpgrade("fonts")
                                      // }
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                            {/* color selection for name */}

                            {/* name or number out side choice */}
                            <div
                              style={{
                                height: "80px",
                                display: "flex",
                                backgroundColor: "#ffffff",
                                alignItems: "center",
                              }}
                              className="px-3 py-2  gap-2 rounded-3 shadow-sm"
                            >
                              <h5 className="" style={{ fontSize: "1rem" }}>
                                {t("invitation.nameOrNumberOutSideTheImage")}
                              </h5>
                              <div
                                className={`${styles.switchPoint} ms-auto  switch`}
                                // onClick={handleChangeLogoRemoval}
                              >
                                {" "}
                                <Switch
                                  onChange={() => {
                                    setNumberOutSideToggle(!numberOutSideToggle)
                                  }} // Dispatch the action
                                  // onChange={handleChangeLogoRemoval}
                                  checked={numberOutSideToggle}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  boxShadow="0px"
                                  activeBoxShadow="0px"
                                  width={60}
                                  height={28}
                                  handleDiameter={24}
                                  onColor="#477BFF" // Background color when checked (on)
                                  // offColor="#FF5722" // Background color when unchecked (off)
                                  onHandleColor="#FFFFFF" // Handle color when checked
                                  offHandleColor="#FFFFFF" // Handle color when unchecked
                                />
                              </div>
                            </div>

                            {/* remove logo choice */}
                            <div
                              style={{
                                height: "80px",
                                display: "flex",
                                backgroundColor: "#ffffff",
                                alignItems: "center",
                              }}
                              className="px-3 py-2  gap-2 rounded-3 shadow-sm"
                            >
                              <h5 className="" style={{ fontSize: "1rem" }}>
                                {t("invitation.removeLogo")}
                              </h5>
                              <div
                                className={`${styles.switchPoint} ms-auto  switch`}
                              >
                                {" "}
                                <div style={{ position: "relative" }}>
                                  {premium == 1 ? (
                                    <Switch
                                      // onChange={() =>
                                      //   setToggleRemoveLogo(!toggleRemoveLogo)
                                      // }
                                      onChange={handleChangeLogoRemoval}
                                      checked={toggleRemoveLogo}
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      boxShadow="0px"
                                      activeBoxShadow="0px"
                                      width={60}
                                      height={28}
                                      handleDiameter={24}
                                      onColor="#477BFF" // Background color when checked (on)
                                      disabled={false} // First switch is disabled
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        position: "relative",
                                        width: 60,
                                        height: 28,
                                      }}
                                      onClick={handleChangeLogoRemoval}
                                    >
                                      <Switch
                                        // onChange={() =>
                                        //   handleOpenUpgrade("Logo removal")
                                        // }
                                        onChange={handleChangeLogoRemoval}
                                        checked={toggleRemoveLogo}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px"
                                        activeBoxShadow="0px"
                                        width={60}
                                        height={28}
                                        handleDiameter={24}
                                        onColor="#477BFF"
                                        disabled={true}
                                      />
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "50%",
                                          left: "20%",
                                          transform: "translate(-50%, -50%)",
                                          pointerEvents: "none", // Prevent interaction with the icon
                                          fontSize: "18px", // Adjust icon size as needed
                                          color: "black",
                                        }}
                                      >
                                        <MdLock />
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div>
                              <button
                                type="submit"
                                // onClick={(e) => onSubmit(e, "")}
                                className="btn btn-dark"
                                style={{
                                  marginTop: "auto",
                                  marginLeft: "auto",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                  height: "60px",
                                  borderRadius: "5px",
                                  backgroundColor: "#20529B",
                                }} // Ensure it sticks to the bottom
                              >
                                {t("buttons.update")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </FormProvider>

                    {/* update qr size */}
                    <QRSizeModal
                      show={showQrSize}
                      onHide={() => setShowQrSize(false)}
                      qrValue={qrValue}
                      qrSize={qrSize}
                      setQrSize={setQrSize}
                      selectedColor={selectedColor}
                      onConfirm={() => setShowQrSize(false)}
                      qrPosition={qrPosition}
                      uploadedImageRef={uploadedImageRef}
                      qrDivRef={qrDivRef}
                      setQrPosition={setQrPosition}
                    />

                    {/* update name text size */}
                    <NameOrNumberSizeModal
                      showNameSize={showNameSize}
                      onHide={() => setShowNameSize(false)}
                      onConfirm={() => setShowNameSize(false)}
                      selectedFont={selectedFont}
                      nameSize={nameSize}
                      setNameSize={setNameSize}
                      selectedColorName={selectedColorName}
                      // onSizeChange,
                      setNamePosition={setNamePosition}
                      namePosition={namePosition}
                      uploadedImageRef={uploadedImageRef}
                      nameDivRef={nameDivRef}
                    />
                    {/* ///upgrade plan pop up */}
                    <UpgradeToPremiumPopup
                      show={upgrade}
                      onHide={() => setUpgrade(false)}
                      upgradesText={upgradesText}
                      currentEventCreated={event}
                      setCurrentEventCreated={setCurrentEventCreated}
                      type="edit"
                    />
                  </>
                )}
              </div>
            </>
          ) : (
            <div
              style={{ height: "40vh" }}
              className="d-flex justify-content-center align-items-center"
            >
              No qr code design created for this event{" "}
            </div>
          )}
        </div>
      )}
    </>
  )
}
export default InviteDetail
